"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUserSearchSets = exports.defaultMapSearch = exports.defaultUserSearchSetFollowDistrictType = exports.defaultUserSearchSetFollowBuildingType = exports.defaultUserSearchSetRentType = exports.defaultUserSearchSetSaleType = exports.defaultUserSearchSetAllType = void 0;
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
exports.defaultUserSearchSetAllType = {
    userSearchSetId: 23,
    searchSetId: 3,
    name: 'Custom Search 2',
    languageId: 2,
    currencyId: 1,
    listingTypeId: 4,
    layout: '',
    area: '1,2,4',
    district: '15,16,17,18,19,20,39,40,88,89,90,91,92,93',
    keyword: 'south horizon',
    priceMin: 40000,
    priceMax: 60000,
    sizeType: 'G',
    sizeMin: 400,
    sizeMax: 600,
    bedroomMin: 1,
    bedroomMax: 20,
    hasMaidRoom: true,
    hasBalcony: false,
    hasTerrace: false,
    hasRooftop: false,
    hasGarden: false,
    hasParking: true,
    hasOutdoorSpace: true,
    notificationId: 19244,
    notificationEnabled: true,
    notificationFrequency: 'Weekly',
    notificationChannels: [1, 2],
    sortBy: 'district',
    orderBy: 'desc',
    updatedDate: '2018-09-27T17:49:42.12',
    searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Search,
    searchSaveSetTypeReferenceId: 0,
};
exports.defaultUserSearchSetSaleType = {
    userSearchSetId: 33,
    searchSetId: 120,
    name: 'sale',
    languageId: 2,
    currencyId: 3,
    listingTypeId: 1,
    layout: '1,2,3',
    area: '1',
    district: '15,37',
    keyword: '',
    priceMin: 0,
    priceMax: 0,
    sizeType: '',
    sizeMin: 0,
    sizeMax: 0,
    bedroomMin: 0,
    bedroomMax: 20,
    hasMaidRoom: false,
    hasBalcony: false,
    hasTerrace: false,
    hasRooftop: false,
    hasGarden: false,
    hasParking: false,
    hasOutdoorSpace: false,
    notificationId: 19290,
    notificationEnabled: true,
    notificationFrequency: 'Daily',
    notificationChannels: [1, 2],
    sortBy: 'updateddate',
    orderBy: 'desc',
    updatedDate: '2018-09-26T19:17:13.307',
    searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Search,
    searchSaveSetTypeReferenceId: 0,
};
exports.defaultUserSearchSetRentType = {
    userSearchSetId: 19,
    searchSetId: 2,
    name: '自訂搜尋',
    languageId: 2,
    currencyId: 3,
    listingTypeId: 2,
    layout: '',
    area: '1',
    district: '15,37',
    keyword: '',
    priceMin: 40000,
    priceMax: 60000,
    sizeType: '',
    sizeMin: 0,
    sizeMax: 0,
    bedroomMin: 0,
    bedroomMax: 20,
    hasMaidRoom: false,
    hasBalcony: false,
    hasTerrace: false,
    hasRooftop: false,
    hasGarden: false,
    hasParking: false,
    hasOutdoorSpace: false,
    notificationId: 19240,
    notificationEnabled: true,
    notificationFrequency: 'Daily',
    notificationChannels: [1, 2],
    sortBy: 'updateddate',
    orderBy: 'desc',
    updatedDate: '2018-09-26T19:17:13.307',
    searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Search,
    searchSaveSetTypeReferenceId: 0,
};
exports.defaultUserSearchSetFollowBuildingType = {
    userSearchSetId: 31,
    searchSetId: 2,
    name: 'South Horizon',
    languageId: 2,
    currencyId: 3,
    listingTypeId: 2,
    layout: '',
    area: '',
    district: '',
    keyword: 'South Horizon',
    priceMin: 0,
    priceMax: 0,
    sizeType: '',
    sizeMin: 0,
    sizeMax: 0,
    bedroomMin: 0,
    bedroomMax: 20,
    hasMaidRoom: false,
    hasBalcony: false,
    hasTerrace: false,
    hasRooftop: false,
    hasGarden: false,
    hasParking: false,
    hasOutdoorSpace: false,
    notificationId: 19244,
    notificationEnabled: true,
    notificationFrequency: 'Daily',
    notificationChannels: [1, 2],
    sortBy: 'updateddate',
    orderBy: 'desc',
    updatedDate: '2018-09-26T19:17:13.307',
    searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Building,
    searchSaveSetTypeReferenceId: 1151,
};
exports.defaultUserSearchSetFollowDistrictType = __assign(__assign({}, exports.defaultUserSearchSetFollowBuildingType), { userSearchSetId: 32, searchSetId: 3, name: 'Mid-level Central', keyword: '', district: '14', searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.District, searchSaveSetTypeReferenceId: 0 });
exports.defaultMapSearch = {
    userSearchSetId: 2346,
    searchSetId: 2338,
    name: ' Properties for Sale in Mid-levels West or Sai Ying Pun',
    isCustomName: true,
    languageId: 1,
    currencyId: 3,
    listingTypeId: 1,
    layout: '',
    area: '',
    district: '',
    districtNames: null,
    keyword: '',
    priceMin: 0,
    priceMax: 0,
    sizeType: '',
    sizeMin: 0,
    sizeMax: 0,
    bedroomMin: 0,
    bedroomMax: 20,
    hasMaidRoom: null,
    hasBalcony: null,
    hasTerrace: null,
    hasRooftop: null,
    hasGarden: null,
    hasParking: null,
    hasOutdoorSpace: null,
    isMap: true,
    geoString: 'rect-22.285042838355437~114.14393972120888_22.283030026115572~114.14164281158446',
    zoomLevel: 19,
    mapDetailsType: 35,
    expandInMetres: 250,
    geoData: null,
    notificationId: 30400,
    notificationEnabled: true,
    notificationFrequency: 'Daily',
    notificationChannels: [1, 2],
    sortBy: 'qualityscore',
    orderBy: 'desc',
    updatedDate: '2019-12-13T16:08:03.31',
    lastAccessDate: '2019-12-13T16:08:03.2288552',
    searchSaveSetType: 4,
    searchSaveSetTypeReferenceId: null,
};
exports.defaultUserSearchSets = [
    exports.defaultUserSearchSetRentType,
    __assign(__assign({}, exports.defaultUserSearchSetRentType), { userSearchSetId: 11111, notificationChannels: [1], notificationId: 12345 }),
];
